import React, { useEffect, useState } from "react";
import { useSelector, useDispatch, connect } from "react-redux";
import { Link, useLocation, useHistory } from "react-router-dom";
import { toggleSearchBar } from "../../actions/settingsAction";
import { MODE_SETTING } from "../../actions";

import trainningCommonImg from "../../assets/images/Training_CommonMenu.svg"
import aboutImg from "../../assets/images/About_CommonMenu.svg"
import companyImg from "../../assets/images/ABout_Comp_CommonMenu.svg"
import contactUs from "../../assets/images/Conatct_Us_CommonMenu.svg"
import legalInfo from "../../assets/images/Legal_CommonMenu.svg"
import privacyImg from "../../assets/images/Privacy_CommonMenu.svg"
import partnerImg from "../../assets/images/Partners_CommonMenu.svg"
import licencesImg from "../../assets/images/Licenses_CommonMenu.svg"
import userSetting from "../../assets/images/user_settings.svg"
import userGuide from "../../assets/images/guidance.svg"
import userGuideReport from "../../assets/images/UserGuide_CommonMenu.svg"
import QuantumSvg from "../../assets/images/menu_icons/Quantum_IconMain.svg"
import returnButton from "../../assets/images/Return_BTN.svg";



const Header = (
  {
    toggleSearchBar
  }) => {
  const location = useLocation();
  const history = useHistory();
  const [isModal, setModal] = useState(false);
  const dispatch = useDispatch();
  const orgName = useSelector(
    (state) =>
      state?.summary?.localClient?.orgName || state?.summary?.clients?.data?.[0]?.orgName
  );
  const authType = useSelector(
    (state) =>
      state?.auth?.user?.accessLevel
  );
  const id = useSelector(
    (state) =>
      state?.summary?.localClient?._id || state?.summary?.clients?.data?.[0]?._id
  );
  const mode = useSelector(
    (state) =>
      location.pathname.includes('/remediation-mode') ? "remediation-mode" : state?.summary?.modes?.data || "assessment-mode"
  );

  const [currentRoute, setCurrentRoute] = useState("dashboard");

  const [activeServiceMenuItem, setActiveServiceMenuItem] = useState("valkyrie");

  const handleModeClick = (v) => {
    dispatch({
      type: MODE_SETTING,
      data: v,
    });
    if (v === "remediation-mode") {
      history.push("/remediation-mode/overview");
    }
    if (v === "assessment-mode") {
      history.push("/");
      /*history.push("/assets/#hostsDiscovered");*/
    }
  };

  let selectedRoute = "dashboard";

  useEffect(() => {
    const pathname = location.pathname;
    if (pathname === "/summary") {
      selectedRoute = "dashboard";
    } else if (
      //Security Healthcheck
      pathname.indexOf("security") !== -1 ||
      pathname === "/dns-health" ||
      pathname === "/sub-domain" ||
      pathname === "/known-vulnerabilities" ||
      pathname === "/ssl-certificates" ||
      pathname === "/web-technology"
    ) {
      selectedRoute = "security";
    } else if (
      //Brand Security
      pathname.indexOf("brand") !== -1 ||
      pathname === "/brand-mention" || 
      pathname === "/mobile-apps" || 
      pathname === "/look-alike" || 
      pathname === "/social-media"
    ) {
      selectedRoute = "brand";
    } else if (
      //Breach Detection
      pathname.indexOf("breach") !== -1 ||
      pathname === "/stolen-credentials" ||
      pathname === "/malware-credentials" ||
      pathname === "/source-code" ||
      pathname === "/leaked-sessions" ||
      pathname === "/cloud-bucket" ||
      pathname === "/ip-blacklist" ||
      pathname === "/pil" ||
      pathname === "/pastebin" 
    ) {
      selectedRoute = "breach";
    } else if (
      //Assets Monitoring
      pathname === "/assets" || 
      pathname === "/assets/"
    ) {
      selectedRoute = "assets";
    } else if (
      //Risk Management
      pathname === "/risk"
    ) {
      selectedRoute = "risk";
    } else if (
      //Settings
      pathname === "/profile"
    ) {
      selectedRoute = "profile";
    } else if (
      //Quantum Readiness
      pathname.indexOf("quantum") !== -1 || 
      pathname === "/overview"
    ) {
      selectedRoute = "quantum";
    } else if (
      pathname === '/ValkyrieServices'
    ) {
      selectedRoute = "services";
      setActiveServiceMenuItem("valkyrie");
    } else if (
      pathname === '/kb'
    ) {
      selectedRoute = "knowledge";
      setActiveServiceMenuItem("knowledge");
  }
    setCurrentRoute(selectedRoute);
  }, [location.pathname]);

  const LogoutModal = ({ isModal, setModal }) => (
    <div className={`modal fade  ${isModal ? "d-block show" : ""}`} id="exampleModal">
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">
              Log out?
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => setModal(false)}
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="modal-body">
            <p>Are you sure you want to Logout?</p>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-round btn-default"
              data-dismiss="modal"
              onClick={() => setModal(false)}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-round btn-primary"
              onClick={() => {
                localStorage.clear();
                window.location.replace("/login");
              }}
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  );


  return (
    <>
      {/*{location.pathname.replace('/', '') !== 'services' ?*/}
      {!['services', 'kb', 'about','contact', 'legal', 'privacy', 'partners', 'licenses', 'company-profile'].includes(location.pathname.replace('/', '').split('#')[0]) ?
        <>
          {/* MAIN Header (Standard View) */}
          <header>
            <div className="nav_main">
              <div className="left_box_1">
                <div className="logo_img">
                  <img src="../assets/images/image-gallery/logo.svg" className="img-fluid" alt=""/>
                </div>
                {mode === "settings-mode" && <>
                  <Link to="/summary" onClick={() => {
                    handleModeClick('assessment-mode');
                  }}>
                    <div className="activeheader text_logo_box">
                      <p>
                        {'<< Return'}
                        <span style={{
                          padding: ' 0px 0px 0px 14px;'
                        }}>to iOdin Panel</span>
                      </p>
                      <div className="circle_button">
                        <div className="inner_box">
                          <img src={returnButton} className="img-fluid w-100 h-100" alt=""/>
                        </div>
                      </div>
                    </div>
                  </Link></>
                }

                {mode !== 'settings-mode' && <>
                  <Link to={mode === 'remediation-mode' || authType === 'remediation-mode' ? "/remediation-mode/overview" : "/summary"} onClick={() => 
                    handleModeClick('assessment-mode')
                  }>
                  <div className={currentRoute === "dashboard" ? "text_logo_box activeheader" : "text_logo_box"}>
                    <p>
                      Home/
                      <span>Dashboard</span>
                    </p>
                    <div className="circle_button">
                      <div className="inner_box">
                        <img src={"../assets/images/image-gallery/dashboard.svg"} className="img-fluid" alt=""/>
                      </div>
                    </div>
                  </div>
                  </Link>
                    {mode !== "remediation-mode" && <>
                      <Link to="/assets/#hostsDiscovered">
                      <div className={currentRoute === "assets" ? "text_logo_box activeheader" : "text_logo_box"}>
                        <p>
                          Asset
                          <span>Monitoring</span>
                        </p>
                        <div className="circle_button">
                          <div className="inner_box">
                            <img src={"../assets/images/Assets_IconMain_.svg"} className="img-fluid" alt=""/>
                          </div>
                        </div>
                      </div>
                      </Link>
                      <Link to="/security/dns-health">
                      <div className={currentRoute === "security" ? "text_logo_box activeheader" : "text_logo_box"}>
                        <p>
                          Security
                          <span>Healthcheck</span>
                        </p>
                        <div className="circle_button">
                          <div className="inner_box">
                            <img src="../assets/images/Health_IconMain_.svg" className="img-fluid" alt=""/>
                          </div>
                        </div>
                      </div>
                      </Link>
                      <Link to="/brand/brand-mention">
                      <div className={currentRoute === "brand" ? "text_logo_box activeheader" : "text_logo_box"}>
                        <p>
                          Brand
                          <span>Security</span>
                        </p>
                        <div className="circle_button">
                          <div className="inner_box">
                            <img src="../assets/images/Brand_IconMain_.svg" className="img-fluid" alt=""/>
                          </div>
                        </div>
                      </div>
                      </Link>
                      <Link to="/breach/stolen-credentials">
                      <div className={currentRoute === "breach" ? "text_logo_box activeheader" : "text_logo_box"}>
                        <p>
                          Breach
                          <span>Detection</span>
                        </p>
                        <div className="circle_button">
                          <div className="inner_box">
                            <img src="../assets/images/Breach_IconMain_.svg" className="img-fluid" alt=""/>
                          </div>
                        </div>
                      </div>
                      </Link>

                      <Link to="/quantum/overview"> {/* Post Quantum */}
                      <div className={currentRoute === "quantum" ? "text_logo_box activeheader" : "text_logo_box"}>
                        <p>
                          Quantum
                          <span>Readiness</span>
                        </p>
                        <div className="circle_button">
                          <div className="inner_box">
                            <img src={QuantumSvg} className="img-fluid" alt=""/>
                          </div>
                        </div>
                      </div>
                      </Link>

                      <Link onClick={(event) => event.preventDefault()}>{/* Risk Management - TEMP LINKAGE*/}
                      <div className={currentRoute === "risk" ? "text_logo_box activeheader" : "text_logo_box"}>
                        <p>
                          Compliance
                          <span>Management</span>
                        </p>
                        <div className="circle_button">
                          <div className="inner_box">
                            <img src="../assets/images/Risk_Manegement_Main.svg" className="img-fluid" alt=""/>
                          </div>
                        </div>
                      </div>
                      </Link>

                    </>
                    }
                </>
                }
              </div>

                  {/* Middle MODE Menu */}
                  <div className="right_box_2">
                  {mode !== "settings-mode"  &&
                    <>
                    {authType !== 'remediation-mode' && (
                      <div onClick={() => {handleModeClick('assessment-mode');}}
                        className={`go_text ${mode === 'assessment-mode' ? 'active_progressBar' : ''}`}
                        style={{ cursor: 'pointer' }}
                      >
                        <div
                          className="progress"
                          role="progressbar"
                          aria-label="Basic example"
                          aria-valuenow="100"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        >
                          <div
                            className="progress-bar red_progress_bar"
                            style={{ width: "100%" }}
                          ></div>
                        </div>
                        <div className="progress_text">
                          <img src="../assets/images/image-gallery/assesment_mode.svg" className="img-fluid" alt=""/>
                          <p>Assessment Mode.</p>
                        </div>
                      </div>
                    )}
                    <div onClick={() => {handleModeClick('remediation-mode');}}
                      className={`go_text ${mode === 'remediation-mode' ? 'active_progressBar' : ''}`}
                      style={{ cursor: 'pointer' }}
                    >
                      <div
                        className="progress"
                        role="progressbar"
                        aria-label="Basic example"
                        aria-valuenow="100"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      >
                        <div
                          className="progress-bar green_progress_green"
                          style={{ width: "100%" }}
                        ></div>
                      </div>
                      <div className="progress_text">
                        <img src="../assets/images/image-gallery/report_mode.svg" className="img-fluid" alt=""/>
                        <p>Remediation Mode.</p>
                      </div>
                    </div>
                  </>}
                {mode === 'settings-mode' && <>
                  <div
                    style={{ cursor: 'pointer' }}
                    className={`go_text ${mode === 'settings-mode' ? 'active_progressBar' : ''}`}
                  >
                    <div
                      className="progress"
                      role="progressbar"
                      aria-label="Basic example"
                      aria-valuenow="100"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    >
                      <div
                        className="progress-bar green_progress_yellow"
                        style={{ width: "100%" }}
                      ></div>
                    </div>
                    <div className="progress_text">
                      <img src="../assets/images/image-gallery/settings_mode.svg" className="img-fluid" alt=""/>
                      <p>Settings Mode.</p>
                    </div>
                  </div>
                </>
                }
              </div>

              {/* Top-Right Menu */}
              <div className="d-flex">
                {mode !== 'settings-mode' &&
                  <>
                    {/* Top-Right Menu - Left Side */}
                    <div className="left_box_1 mr-5">
                      <Link to="/services#identify" onClick={() => {
                        handleModeClick('service-mode');
                      }}>
                        <div className={"text_logo_box"}>
                          <p>
                            Valkyrie
                            <span>Special</span>
                            Services
                          </p>
                          <div className="circle_button">
                            <div className="inner_box">
                              <img src="../assets/images/valkyrie_service.svg" className="img-fluid" alt=""/>
                            </div>
                          </div>
                        </div>
                      </Link>

                      {authType === "Admin" && <>
                      <Link>
                        <div className={"text_logo_box"}>
                          <p>
                            Learning
                            <span>Training</span>
                            Certification
                          </p>
                          <div className="circle_button">
                            <div className="inner_box">
                              <img src={trainningCommonImg} className="img-fluid" alt=""/>
                            </div>
                          </div>
                        </div>
                      </Link>
                      </>}
                    </div>
                    
                    {/* Top-Right Menu - Right Side */}
                    <div className="left_box_1">

                    {authType === "Admin" && <>
                      <Link>
                        <div className={"text_logo_box"}>
                          <p>
                            General 
                            <span>Info</span>
                          </p>
                          <div className="circle_button">
                            <div className="inner_box">
                              <img src={contactUs} className="img-fluid" alt=""/>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </>}

                    {/*{authType === "Admin" && <>*/}
                      <Link to="/kb#scans" onClick={() => {
                        handleModeClick('knowledge-base-mode');
                      }}>
                        <div className={"text_logo_box"}>
                          <p>
                            Userguides
                            <span>Support</span>
                          </p>
                          <div className="circle_button">
                            <div className="inner_box">
                              <img src={userGuideReport} className="img-fluid" alt=""/>
                            </div>
                          </div>
                        </div>
                      </Link>
                    {/*</>}*/}

                      <Link to={`/user/${id}`} onClick={() => {
                        handleModeClick('settings-mode');
                      }}>
                        <div className={currentRoute === "client" ? "text_logo_box activeheader" : "text_logo_box"}>
                          <p>
                            User
                            <span>Settings</span>
                          </p>
                          <div className="circle_button">
                            <div className="inner_box">
                              <img src={userSetting} className="img-fluid" alt=""/>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </>
                }

                <div className="right_box_3">
                  <div className="sign_out">
                    <a href="javascript:void(0)" onClick={() => setModal(true)}>
                      <img src="../assets/images/image-gallery/signout.svg" className="img-fluid" alt=""/>
                      <p>Sign Out</p>
                    </a>
                    <p>Signed in as: <span style={{ maxWidth: '100px' }}>{orgName}</span></p>
                  </div>
                </div>
              </div>
            </div>
            <LogoutModal isModal={isModal} setModal={setModal} />
          </header>

        </> : <>
          {/* Service Header */}
          <header>
            <div className="nav_main nav_main_serviceHeader">
              <div className="left_box_1">
                <div className="d-flex">
                  <div className="logo_img">
                    <img src="../assets/images/image-gallery/logo.svg" className="img-fluid" alt=""/>
                  </div>
                  <Link to="/summary" >
                    <div className="activeheader text_logo_box">
                      <p>
                        {'<< Return'}
                        <span style={{
                          padding: ' 0px 0px 0px 14px;'
                        }}>to iOdin Panel</span>
                      </p>
                      <div className="circle_button">
                        <div className="inner_box">
                          <img src={returnButton} className="img-fluid imginner_box h-100 w-100" alt=""/>
                        </div>
                      </div>
                    </div>
                  </Link>

                    <div className='blank_space' style={{ margin: '0px 40px' }}></div>
                  {/*TEMP LINKAGE*/}
                  <Link to="/services#identify" onClick={() => 
                    setActiveServiceMenuItem("valkyrie")
                  }>
                    <div className={`text_logo_box ${activeServiceMenuItem === "valkyrie" ? "text_logo_box_bg" : ""}`}>
                      <p>
                        Valkyrie
                        <span>Special</span>
                        Services
                      </p>
                      <div className="circle_button">
                        <div className="inner_box">
                          <img src="../assets/images/valkyrie_service.svg" className="img-fluid" alt=""/>
                        </div>
                      </div>
                    </div>
                  </Link>
                  {/*TEMP LINKAGE*/} {/* TO DO */}
                  {/* NON Clickable Link */}
                  <Link onClick={(event) => event.preventDefault()}>
                    <div className={"text_logo_box"}>
                      <p>
                        Learning
                        <span>Training</span>
                        Certification
                      </p>
                      <div className="circle_button">
                        <div className="inner_box">
                          <img src={trainningCommonImg} className="img-fluid" alt=""/>
                        </div>
                      </div>
                    </div>
                  </Link>

                {/*{authType === "Admin" && <>*/}
                  <Link to="/kb#scans" onClick={() => 
                    setActiveServiceMenuItem("knowledge")
                  }>
                    <div className={`text_logo_box ${activeServiceMenuItem === "knowledge" ? "text_logo_box_bg" : ""}`}>
                      <p>
                        Yggdrasil
                        <span>Knowledge</span>
                        Tree
                      </p>
                      <div className="circle_button">
                        <div className="inner_box">
                          <img src={userGuide} className="img-fluid" alt=""/>
                        </div>
                      </div>
                    </div>
                  </Link>
                {/*</>}*/}

                  <div className='blank_space' style={{ margin: '0px 40px' }}></div>
                  
                  {/*TEMP LINKAGE*/} {/* TO DO */}
                  {authType === "Admin" && <>
                  <Link onClick={(event) => event.preventDefault()}></Link>
                  <Link to="/about">
                    <div className={`text_logo_box ${location.pathname === '/about' ? "text_logo_box_bg" : ""}`}>
                      <p>
                        About
                        <span>Us</span>
                      </p>
                      <div className="circle_button">
                        <div className="inner_box">
                          <img src={aboutImg} className="img-fluid" alt=""/>
                        </div>
                      </div>
                    </div>
                  </Link>
                  </>}

                  {/*TEMP LINKAGE*/} {/* TO DO */}
                  {authType === "Admin" && <>
                  <Link to="/company-profile">
                    <div className={`text_logo_box ${location.pathname === '/company-profile' ? "text_logo_box_bg" : ""}`}>
                      <p>
                        Company
                        <span>Info</span>
                      </p>
                      <div className="circle_button">
                        <div className="inner_box">
                          <img src={companyImg} className="img-fluid" alt=""/>
                        </div>
                      </div>
                    </div>
                  </Link>
                  </>}

                  {/*TEMP LINKAGE*/} {/* TO DO */}
                  {authType === "Admin" && <>
                  <Link to="/contact">
                    <div className={`text_logo_box ${location.pathname === '/contact' ? "text_logo_box_bg" : ""}`}>
                      <p>
                        Contact
                        <span>Us</span>
                      </p>
                      <div className="circle_button">
                        <div className="inner_box">
                          <img src={contactUs} className="img-fluid" alt=""/>
                        </div>
                      </div>
                    </div>
                  </Link>
                  </>}

                  {/*TEMP LINKAGE*/} {/* TO DO */}
                  {authType === "Admin" && <>
                  <Link to="/legal">
                    <div className={`text_logo_box ${location.pathname === '/legal' ? "text_logo_box_bg" : ""}`}>
                      <p>
                        Legal
                        <span>Info</span>
                      </p>
                      <div className="circle_button">
                        <div className="inner_box">
                          <img src={legalInfo} className="img-fluid" alt=""/>
                        </div>
                      </div>
                    </div>
                  </Link>
                  </>}

                  {/*TEMP LINKAGE*/} {/* TO DO */}
                  {authType === "Admin" && <>
                  <Link to="/privacy">
                    <div className={`text_logo_box ${location.pathname === '/privacy' ? "text_logo_box_bg" : ""}`}>
                      <p>
                        Privacy
                        <span>Info</span>
                      </p>
                      <div className="circle_button">
                        <div className="inner_box">
                          <img src={privacyImg} className="img-fluid" alt=""/>
                        </div>
                      </div>
                    </div>
                  </Link>
                  </>}

                  {/*TEMP LINKAGE*/} {/* TO DO */}
                  {authType === "Admin" && <>
                  <Link to="/partners">
                    <div className={`text_logo_box ${location.pathname === '/partners' ? "text_logo_box_bg" : ""}`}>
                      <p>
                        Partners
                        <span>Info</span>
                      </p>
                      <div className="circle_button">
                        <div className="inner_box">
                          <img src={partnerImg} className="img-fluid" alt=""/>
                        </div>
                      </div>
                    </div>
                  </Link>
                  </>}

                  {/*TEMP LINKAGE*/} {/* TO DO */}
                  {authType === "Admin" && <>
                  <Link to="/licenses">
                    <div className={`text_logo_box ${location.pathname === '/licenses' ? "text_logo_box_bg" : ""}`}>
                      <p>
                        Licences/
                        <span>Certifications</span>
                      </p>
                      <div className="circle_button">
                        <div className="inner_box">
                          <img src={licencesImg} className="img-fluid" alt=""/>
                        </div>
                      </div>
                    </div>
                  </Link>
                  </>}

                </div>
                <div className="d-flex">
                  {/* NON Clickable Link */}
                  <Link onClick={(event) => event.preventDefault()}>
                    <div className='text_logo_box'>
                      <p>
                        User Services
                      </p>
                    </div>
                  </Link>

                  {/*TEMP LINKAGE*/} {/* TO DO */}
                  {authType === "Admin" && <>
                  <Link to="/contact">
                    <div className={`text_logo_box ${location.pathname === '/contact' ? "text_logo_box_bg" : ""}`}>
                      <p>
                        Request
                        <span>Support</span>
                      </p>
                      <div className="circle_button">
                        <div className="inner_box">
                          <img src={contactUs} className="img-fluid" alt=""/>
                        </div>
                      </div>
                    </div>
                  </Link>
                  </>}

                  <Link to={`/user/${id}`} onClick={() => {
                    handleModeClick('settings-mode');
                  }}>
                    <div className={"text_logo_box"}>
                      <p>
                        User
                        <span>Settings</span>
                      </p>
                      <div className="circle_button">
                        <div className="inner_box">
                          <img src={userSetting} className="img-fluid" alt=""/>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="right_box_3">
                <div className="sign_out">
                  <a href="javascript:void(0)" onClick={() => setModal(true)}>
                    <img src="../assets/images/image-gallery/signout.svg" className="img-fluid" alt=""/>
                    <p>Sign Out</p>
                  </a>
                  <p>Signed in as: <span style={{ maxWidth: '100px' }}>{orgName}</span></p>
                </div>
              </div>
            </div>
            <LogoutModal isModal={isModal} setModal={setModal} />
          </header>
        </>
      }
    </>

  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  toggleSearchBar: (e) => dispatch(toggleSearchBar(e)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);